module.exports = __webpack_public_path__ + "img/wzfp_1.b6be629e.jpg";